import { getNow } from 'src/shared/helpers/dateHelpers';
import { E_SHORTCUT_DATE_TYPE } from 'src/ui/components/Input/DateTimeInput/constants';
export var getDateIntervalForShortcut = function (shortcutType) {
    var now = getNow();
    switch (shortcutType) {
        case E_SHORTCUT_DATE_TYPE.LAST_HOUR: {
            return { shortcutDate: E_SHORTCUT_DATE_TYPE.LAST_HOUR, startDate: now.minus({ hours: 1 }), endDate: now };
        }
        case E_SHORTCUT_DATE_TYPE.TODAY: {
            return {
                shortcutDate: E_SHORTCUT_DATE_TYPE.TODAY,
                startDate: now.set({ hour: 0, minute: 0, second: 0 }),
                endDate: now,
            };
        }
        case E_SHORTCUT_DATE_TYPE.LAST_24_HOURS: {
            return {
                shortcutDate: E_SHORTCUT_DATE_TYPE.LAST_24_HOURS,
                startDate: now.minus({ hours: 24 }),
                endDate: now,
            };
        }
        case E_SHORTCUT_DATE_TYPE.YESTERDAY: {
            return {
                shortcutDate: E_SHORTCUT_DATE_TYPE.YESTERDAY,
                startDate: now.minus({ days: 1 }).set({ hour: 0, minute: 0, second: 0 }),
                endDate: now.minus({ days: 1 }).set({ hour: 23, minute: 59, second: 59 }),
            };
        }
        case E_SHORTCUT_DATE_TYPE.THIS_WEEK: {
            return {
                shortcutDate: E_SHORTCUT_DATE_TYPE.THIS_WEEK,
                startDate: now.set({ weekDay: 1, hour: 0, minute: 0, second: 0 }),
                endDate: now,
            };
        }
        case E_SHORTCUT_DATE_TYPE.THIS_MONTH: {
            return {
                shortcutDate: E_SHORTCUT_DATE_TYPE.THIS_MONTH,
                startDate: now.set({ day: 1, hour: 0, minute: 0, second: 0 }),
                endDate: now,
            };
        }
    }
};
